import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, Card, Alert } from 'react-bootstrap';
import { signInRequestExt } from '../../store/modules/auth/doctor/actions';
import logo from '../../assets/logo.png';
import RecuperarSenhaModal from '../../components/RecuperarSenhaModal';

export default function SignInMedExterno() {
  const dispatch = useDispatch();
  const authError = useSelector(state => state.doctor.authError);
  const [validated, setValidated] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    if (!event.currentTarget.checkValidity()) {
      event.stopPropagation();
    } else {
      const cpf = event.target.elements.formBasicCPF.value;
      const senha = event.target.elements.formBasicSenha.value;
      dispatch(signInRequestExt(cpf, senha));
    }

    setValidated(true);
  };

  return (
    <>
      <Card className="m-5 mx-auto" style={{ maxWidth: '300px' }}>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="text-center">
              <img
                className="img-fluid rounded-circle center-block hoverable img-profile mx-2 mb-2"
                src={logo}
                alt="logo"
                width={70}
                height={70}
              />
            </div>
            <Form.Group controlId="formBasicCPF">
              <Form.Label>CPF do Médico</Form.Label>
              <Form.Control required type="text" placeholder="Seu CPF" />
              <Form.Control.Feedback type="invalid">
                Digite seu CPF.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formBasicSenha">
              <Form.Label>Senha</Form.Label>
              <Form.Control
                required
                type="password"
                placeholder="Sua senha secreta"
              />
              <Form.Control.Feedback type="invalid">
                Digite sua senha.
              </Form.Control.Feedback>
            </Form.Group>
            {authError && (
              <Alert variant="danger" className="mb-3">
                {authError}
              </Alert>
            )}

            <Button block type="submit">
              Entrar
            </Button>
            <Button
              variant="warning"
              block
              onClick={() => setShowResetPasswordModal(true)}
            >
              Esqueci minha senha
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <RecuperarSenhaModal
        showResetPasswordModal={showResetPasswordModal}
        setShowResetPasswordModal={setShowResetPasswordModal}
        userType="externo"

      />
    </>
  );
}
